<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter">
<header>
<h1 class="title" epub:type="title"><a id="page_3">L<span class="small">ETTERS</span> W<span class="small">RITTEN AND</span> N<span class="small">OT</span> S<span class="small">ENT</span></a></h1><a id="page_3">
</a></header><a id="page_3">
<p class="title1"><em>poems</em></p>
<p class="imagetp"><img alt="Images" src="images/tp.jpg"/></p>
<p class="title2">W<span class="small">ILLIAM</span> L<span class="small">OUIS</span>-D<span class="small">REYFUS</span></p>
<p class="logo"><img alt="figure" class="middle" src="images/pub.jpg"/> Red Hen Press | <em>Pasadena, CA</em></p>
</a></section><a id="page_3">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?8a4fdbd2